import {
  Directive, effect,
  ElementRef,
  HostListener,
  inject,
  Renderer2, untracked,
} from '@angular/core';
import { RouterStore } from '@route/data-access';

@Directive({
  selector: '[backButton]',
  standalone: true,
})
export class BackButtonDirective {
  private readonly routerStore = inject(RouterStore);
  constructor(private el: ElementRef, private renderer: Renderer2) {
    effect(() => {
      const path = this.routerStore.backNavigationPath();
      untracked(() => {
        if (path) {
          return this.renderer.removeClass(this.el.nativeElement, 'invisible');
        }
        return this.renderer.addClass(this.el.nativeElement, 'invisible');
      })
    })
  }

  @HostListener('click')
  onClick(): void {
    this.routerStore.goBack();
  }
}
